<template>
  <div :class="$style.profile">
    <div class="row">
      <div class="col-xl-4">
        <div
          class="card"
          :class="$style.header"
          :style="{ backgroundImage: 'url(' + background + ')' }"
        >
          <div
            :class="
              'card-body text-center ' + (this.uploading ? 'gray-scale' : '')
            "
          >
            <cui-avatar
              :src="userInfo.photoURL"
              :size="110"
              :bordered="true"
              borderColor="white"
              :click="openUploadAvatar"
            />
            <br />
            <input
              type="file"
              ref="uploadAvatar"
              accept="image/gif, image/jpeg, image/png"
              style="opacity: 0; position: absolute; top: 0; width: 0"
              @change="uploadAvatar"
            />
            <br />
            <br />
            <p class="text-white mt-2">
              {{ $t("profile.lastSignInTime") }}: {{ userInfo.lastSignInTime }}
            </p>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <h5 class="mb-3 text-black">
              <strong>{{ $t("plan.detail") }}</strong>
            </h5>
            <div v-if="user.metadata && user.metadata.userPlan">
              <p v-for="key in fields">
                {{ $t("plan." + key) }}:
                <span
                  v-if="
                    user.metadata.usage.hasOwnProperty(key.replace('max_', ''))
                  "
                >
                  {{ user.metadata.usage[key.replace("max_", "")] }}/</span
                >{{ user.metadata.userPlan.details[key] }}
              </p>
              <p v-if="user.metadata.userPlan.expired">
                <strong>{{ $t("plan.expired") }}</strong
                >: &nbsp;{{ user.metadata.userPlan.expired | formatDate }}
              </p>
              <router-link to="/plan"
                ><a-button type="primary">{{
                  $t("plan.upgrade")
                }}</a-button></router-link
              >
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-8">
        <div :class="$style.socialInfo" class="card card-body mb-4">
          <div>
            <h2>
              <span class="text-black mr-2">
                <strong>{{
                  userInfo.displayName || userInfo.phoneNumber
                }}</strong>
              </span>
              <small
                class="text-muted"
                :style="'display: ' + (settings.isMobileView ? 'block' : '')"
                >{{ userInfo.email }}</small
              >
            </h2>
            <p class="mb-1">{{ userRanking }}</p>
          </div>
          <div :class="$style.socialCounts">
            <div class="text-center mr-3">
              <a-button v-if="!editMode" icon="edit" @click="toggleEditMode">{{
                $t("profile.edit")
              }}</a-button>
            </div>
          </div>
          <div
            :class="$style.formProfile"
            :style="'display: ' + (editMode ? '' : 'none')"
          >
            <a-form
              class="login-form"
              layout="horizontal"
              :form="form"
              @submit="saveProfile"
            >
              <form-item :label="$t('signin.mobile')">
                <strong>{{ userInfo.phoneNumber }}</strong>
              </form-item>
              <form-item :label="$t('profile.fullName')">
                <a-input
                  v-decorator="[
                    'displayName',
                    {
                      rules: [
                        {
                          required: true,
                          message: $t('profile.fullNameRequired'),
                        },
                      ],
                    },
                  ]"
                />
              </form-item>
              <form-item :label="$t('profile.email')">
                <a-input
                  v-decorator="[
                    'email',
                    {
                      rules: [
                        {
                          required: true,
                          message: $t('profile.emailRequired'),
                        },
                      ],
                    },
                  ]"
                />
              </form-item>
              <form-item :label="settings.isMobileView ? '' : ' '">
                <a-button
                  type="primary"
                  htmlType="submit"
                  class="login-form-button"
                  :loading="loading"
                  >{{ $t("profile.update") }}</a-button
                >
              </form-item>
            </a-form>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <h5 class="mb-3 text-black">
              <strong>{{ $t("profile.transaction_history") }}</strong>
            </h5>
            <dl class="row">
              <div class="col-xl-12">
                <a-table
                  :columns="columns"
                  :rowKey="(record) => record.id"
                  :dataSource="trans_history"
                  :loading="loading"
                >
                  <template slot="stt" slot-scope="id, record, index">
                    {{ index + 1 }}
                  </template>
                  <template slot="created" slot-scope="created">
                    {{ created | formatDate }}
                  </template>
                  <template slot="price" slot-scope="price">
                    <money :value="price" />
                  </template>
                  <template slot="status" slot-scope="status">
                    {{ $t("transaction.status_" + status) }}
                  </template>
                </a-table>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  background,
  lastActivity,
  coursesEnd,
  adress,
  profSkills,
  lastCompanies,
  personal,
} from "./data.json";
import CuiAvatar from "@/components/CleanUIComponents/Avatar";
import user from "@/mixins/user";
import api from "@/mixins/api";
import helper from "@/mixins/helper";
import FormItem from "@/components/CleanUIComponents/FormItem";
import { mapState } from "vuex";
import Money from "@/components/Other/money";

export default {
  components: {
    CuiAvatar,
    FormItem,
    Money,
  },
  computed: {
    ...mapState(["settings"]),
    ...mapState(["user"]),
  },
  data: function () {
    const columns = [
      {
        title: "#",
        width: "30px",
        dataIndex: "id",
        scopedSlots: { customRender: "stt" },
      },
      {
        title: this.$t("transaction.date"),
        dataIndex: "created",
        scopedSlots: { customRender: "created" },
      },
      {
        title: this.$t("transaction.amount"),
        dataIndex: "price",
        width: "30%",
        scopedSlots: { customRender: "price" },
      },
      {
        title: this.$t("transaction.status"),
        width: "20%",
        dataIndex: "status",
        scopedSlots: { customRender: "status" },
      },
    ];

    return {
      editMode: false,
      loading: false,
      form: this.$form.createForm(this),
      uploading: false,

      background,
      lastActivity,
      coursesEnd,
      adress,
      profSkills,
      lastCompanies,
      personal,
      columns,
      trans_history: [],
      userRanking: "",
      fields: [
        "max_test",
        "max_live",
        "max_game",
        "max_player",
        "max_question",
        "export",
      ],
    };
  },
  watch: {
    userInfo(value) {
      this.form.setFieldsValue({
        displayName: value.displayName,
        email: value.email,
      });
    },
  },
  methods: {
    toggleEditMode() {
      this.editMode = !this.editMode;
    },
    saveProfile(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        this.loading = true;
        this.updateProfile({
          displayName: values["displayName"],
          email: values["email"],
        }).then((status) => {
          this.loading = false;
          this.editMode = false;
          window.location.reload();
        });
      });
    },
    openUploadAvatar() {
      if (this.uploading) return;
      this.$refs["uploadAvatar"].click();
    },
    uploadAvatar: function (e) {
      if (e.target.files.length) {
        let file = e.target.files[0];
        this.uploading = true;
        this.imgurUpload(file)
          .then((url) => {
            if (url) {
              this.updateProfile({
                photoURL: url,
              });
            }
          })
          .then(() => {
            this.uploading = false;
          })
          .catch((e) => {
            console.log(e);
            this.uploading = false;
            this.$notification["error"]({
              message: this.$t("notify.title.error") + " upload",
              description: this.$t("notify.content.upload_photo_failed"),
            });
          });
      }
    },
    loadHistory() {
      this.api("transaction/history").then((res) => {
        this.trans_history = res;
      });
    },
  },
  mounted() {
    // this.loadHistory();
  },
  mixins: [user, api, helper],
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
